import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

export const useChangePassword = (axiosPrivate, endpoint, id, navigate) => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const updatePassword = async (data) => {
        try {
            await axiosPrivate.post(`${endpoint}/${id}`, data);
            enqueueSnackbar(t("passwordIsUpdated"), { variant: "success" });
            navigate(-1)

        } catch (err) {
            if (err?.response?.status === 400) {
                enqueueSnackbar(err?.response?.data.description, { variant: "error" });
            }
            else {
                enqueueSnackbar(t("updateMessageError"), { variant: "error" });
            }
        }
    };



    return updatePassword;
};
